import {
    styled,
    $primaryColorsGreen,
} from '@acko-tech/building-blocks.ui.common';

export const $primaryColorsV2 = $primaryColorsGreen;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    box-sizing: border-box;
    border: 1px solid #e7e7f0;
    border-radius: 8px;
    padding: 12px 16px 16px;
    margin-top: 16px;

    ${(props) => props.styles}
`;

export const FieldContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Field = styled.div`
    color: #5b5675;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;

export const Wrapper = styled.div`
    // margin-bottom: 24px;
`;
